import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

class AuthService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add token to requests
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  // Signup
  async signup(email, password, firstName, lastName, phone) {
    try {
      // Generate username from email (remove dots, add random suffix)
      const username = email.split('@')[0].replace(/\./g, '_') + '_' + Math.random().toString(36).substr(2, 5);
      
      const response = await this.api.post('/auth/register', {
        username,
        email,
        password,
        user_type: 'seller',
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || 'Signup failed',
      };
    }
  }

  // Login
  async login(emailOrUsername, password) {
    try {
      const response = await this.api.post('/auth/login', { 
        email: emailOrUsername,
        password 
      });
      const { token, user } = response.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.response?.data?.message || 'Login failed',
      };
    }
  }

  // Get token to verify authentication
  async verifyToken() {
    try {
      const response = await this.api.get('/auth/verify-token');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Token verification failed',
      };
    }
  }

  // Refresh token
  async refreshToken() {
    try {
      const response = await this.api.post('/auth/refresh-token');
      const { token } = response.data;
      localStorage.setItem('authToken', token);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Token refresh failed',
      };
    }
  }

  // Logout
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }

  // Get current user
  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  // Check if authenticated
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }

  getToken() {
    return localStorage.getItem('authToken');
  }
}

export default new AuthService();
